module.exports = __webpack_public_path__ + "static/media/YF_52_12.1961925a.jpg";